<!-- https://getbootstrap.com/docs/5.3/examples/product/ -->
<app-page-title [title]="'About AthleticLIVE'"> </app-page-title>
<div class="px-3 py-3 my-3 text-center">
  <img class="d-block mx-auto mb-4" src="/assets/images/alive_gradient.svg" alt="AthleticLIVE" width="200" />
  <h1 class="display-5 fw-bold text-body-emphasis">Superior Live Results</h1>
  <div class="col-lg-6 mx-auto">
    <p class="lead mb-4">Get professional track and field results with AthleticLIVE.</p>
  </div>
</div>
<div class="row g-4 p-3 row-cols-1 row-cols-lg-3">
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="environment.icons.search"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Autocomplete Search</h3>
      <p>Search for teams and athletes and view suggestions as you type. Quickly locate the results you want.</p>
      <a href="https://live.athletic.net/features/search" class="btn btn-primary me-2">View the Docs</a>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'calendar-days']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Event Schedules</h3>
      <p>View events in order or by day. Requires timer setup.</p>
      <a href="https://live.athletic.net/features/schedule" class="btn btn-primary me-2">View the Docs</a>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="environment.icons.teams"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Team & Athlete Pages</h3>
      <p>View all results for a single team or athlete.</p>
      <a href="https://live.athletic.net/features/results" class="btn btn-primary me-2">View the Docs</a>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'grid-4']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Split Grids</h3>
      <p>
        Display all splits for a given event in a grid. Sort by split. The first row and column freeze so you can always
        see the athlete and the split you are at in the grid.
      </p>
      <a href="https://live.athletic.net/features/results" class="btn btn-primary me-2">View the Docs</a
      ><a href="https://results.wayzatatiming.com/meets/6696/xc-events/219395/splits" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['fas', 'table']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Field Series Grids</h3>
      <p>
        Display all field series for a given event in a grid. See the best attempt. The first row and column freeze so
        you can always see the athlete you're viewing in the grid.
      </p>
      <a href="https://live.athletic.net/features/results" class="btn btn-primary me-2">View the Docs</a
      ><a href="https://live.athletictiming.net/meets/2469/events/128280/horizontal-series" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="environment.icons.record"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Record and Event Standard Reports</h3>
      <p>View all records and event standards for a meet. See if any have been broken.</p>
      <a href="https://live.athletictiming.net/meets/2469/reports/records" class="btn btn-secondary">See an Example</a>
    </div>
  </div>

  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="environment.icons.fieldApp"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">AthleticFIELD App for Live Field Results</h3>
      <p>
        AthleticFIELD allows timers to deliver real-time field results. Available as an iOS App, and Android App, and a
        Windows EXE.
      </p>
      <a
        href="https://support.athletic.net/article/yjnpncw2gr-athletic-field-general-introduction"
        class="btn btn-primary me-2"
        >View the Docs</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="environment.icons.athleticSb"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">AthleticSB for Physical Scoreboards</h3>
      <p>
        AthleticSB allows timers to display professional in-person scoreboards at any screen size without the hassle of
        creating a scoreboard from scratch. Show live track standings, compiled standings, field result boards, XC
        scores, and more
      </p>
      <a href="https://support.athletic.net/article/2bp64whbed-athletic-sb-introduction" class="btn btn-primary me-2"
        >View the Docs</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'shield']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Team Logos</h3>
      <p>Connect your AthleticLIVE meet to your Athletic.net meet to show team logos on your live results</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'exclamation-circle']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Athlete/Team PRs and SRs</h3>
      <p>Connect your AthleticLIVE meet to your Athletic.net meet to PRs and SRs next to each result</p>
      <a
        href="https://support.athletic.net/article/kwbnosndhn-show-prs-and-srs-on-live-results"
        class="btn btn-primary me-2"
        >View the Docs</a
      ><a href="https://live.athletictiming.net/meets/2469/events/128280/results" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'ranking-star']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Athlete Rankings</h3>
      <p>
        Connect your AthleticLIVE meet to your Athletic.net meet to recieve Top 100 national, Top 50 state rankings on
        live scoreboards and final results. See a US#1 In real time!
      </p>
      <a href="https://results.wayzatatiming.com/meets/21985/events/767046/results" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'camera-movie']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Race Videos</h3>
      <p>
        Record race videos on your mobile device and upload them to AthleticLIVE. Allow people to view those videos
        within the live results
      </p>
      <a href="https://support.athletic.net/article/zkdsk1nz1t-record-full-race-videos" class="btn btn-primary me-2"
        >View the Docs</a
      ><a href="https://live.herostiming.com/meets/19578/events/754169/results" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'camcorder']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Field Videos</h3>
      <p>
        Record field videos within your AthleticFIELD app and upload them to AthleticLIVE. Allow coaches and parents to
        get on-demand access to videos just minutes after the attempt.
      </p>
      <a href="https://support.athletic.net/article/73f7gf32dz-record-field-videos" class="btn btn-primary me-2"
        >View the Docs</a
      ><a href="https://live.athletictiming.net/meets/22092/events/769770/results" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['fas', 'images']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Finish Line Image Export</h3>
      <p>
        Export images from FinishLynx and immediately display next to each result. Export a single race image for each
        heat. Images can be obtained from line scan cameras or Identilynx cameras.
      </p>
      <a href="https://support.athletic.net/article/v5wsue7jbw-configure-lynx-image-export" class="btn btn-primary me-2"
        >View the Docs</a
      ><a href="https://live.athletictiming.net/meets/2469/events/128260/results" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="environment.icons.protest"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Protest Management</h3>
      <p>
        AthleticLIVE can help make the protest process more transparent by showing whether a result is unofficial or
        official, the time left in a protest period, and whether or not an event's results are under protest.
      </p>
      <a href="https://support.athletic.net/article/hddngjcfsd-protest-management" class="btn btn-primary me-2"
        >View the Docs</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'square-star']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Bubble Qualifying Time</h3>
      <p>
        Show viewers up-to-the-second qualifiers and the bubble time (the time an athlete must run to qualify) when you
        create results from FinishLynx or your meet management system. Qualifiers update with every result.
      </p>
      <a
        href="https://support.athletic.net/article/vn1hn5zyk9-show-live-qualifiers-on-the-live-scoreboard"
        class="btn btn-primary me-2"
        >View the Docs</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'list-ol']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Compiled and By Heat/Flight Standings</h3>
      <p>
        View real-time standings as an event progresses. If you're on Heat 9 of a 20 heat event, the live scoreboard
        will show compiled standings through heat 9.
      </p>
      <a href="https://support.athletic.net/article/862ump6xyo-advanced-lynx-setup" class="btn btn-primary me-2"
        >View the Docs</a
      >
    </div>
  </div>

  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'ranking-star']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">T&F Team Scores</h3>
      <p>View team scores that update after each event</p>
      <a
        href="https://live.athletictiming.net/meets/2469/scores/genDivMSR%7C2469%7C2549%7C3/list"
        class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'grid']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">T&F Score Spreadsheet</h3>
      <p>View how each team scored points and gain visibility into team strengths and weaknesses.</p>
      <a
        href="https://live.athletictiming.net/meets/2469/scores/genDivMSR%7C2469%7C2549%7C3/spreadsheet"
        class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'ranking-star']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">XC Team Scores</h3>
      <p>
        View cross country team scores and see average, gap, spread, and how each athlete contributed to the team score.
      </p>
      <a href="https://results.wayzatatiming.com/meets/6696/xc-events/219395/scores" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'line-columns']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">XC Team Split Scores</h3>
      <p>View scores at each split and see how teams progressed throughout the race.</p>
      <a href="https://results.wayzatatiming.com/meets/6696/xc-events/219395/split-scores" class="btn btn-secondary"
        >See an Example</a
      >
    </div>
  </div>

  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="environment.icons.followOn"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Follow Athletes, Teams, and Events</h3>
      <p>
        Follow athletes and teams across meets. Follow events in each meet. Quickly view all follows on the meet
        dashboard.
      </p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="environment.icons.fieldApp"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">AthleticAPP Result Notifications</h3>
      <p>Get a notification on your app whenever an athlete you follow has a new result.</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['fab', 'square-x-twitter']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Automated Result Tweets</h3>
      <p>
        Timers can automatically tweet results as soon as they are uploaded from a meet management system. Tweets are
        branded with an Enterprise site.
      </p>
      <a
        href="https://support.athletic.net/article/x301h074r1-automated-result-tweets-by-others"
        class="btn btn-primary me-2"
        >View the Docs</a
      >
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['fab', 'square-x-twitter']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Third Party Automated Result Tweets</h3>
      <p>
        Allow other third parties, such as schools, ADs, or conferences to automatically tweet when new results are
        available.
      </p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'envelope']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Email Result Notifications</h3>
      <p>Allow spectators to sign up and receive notifications when new results are uploaded.</p>
    </div>
  </div>
  <div class="col d-flex align-items-start">
    <div
      class="icon-square text-body-emphasis bg-body-secondary d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3"
    >
      <fa-icon [icon]="['far', 'comment']"></fa-icon>
    </div>
    <div>
      <h3 class="fs-2 text-body-emphasis">Text Message Notifications</h3>
      <p>Sign up for text message notifications when new results occur (not available at every meet)</p>
    </div>
  </div>
</div>
<!--
<div class="row">
    <div class="col col-12 col-md-6 bg-body-tertiary pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
        <div class="my-3 p-3">
            <h2 class="display-5">Live XC Scoreboard</h2>
            <p class="lead">And an even wittier subheading.</p>
        </div>
      <img src="/assets/images/marketing/teamPageResults.png" alt="Bootstrap Themes" width="300" loading="lazy">
    </div>
    <div class="col col-12 col-md-6 text-bg-primary pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
        <div class="my-3 py-3">
            <h2 class="display-5">Live Field Scoreboard test t est test </h2>
            <p class="lead">And an even wittier subheading.</p>
        </div>
      <img src="/assets/images/marketing/teamPageCutoff.png" alt="Bootstrap Themes" width="300" loading="lazy">
    </div>
</div>
<div class="row">
  <div class="col col-12 col-md-6 text-bg-secondary pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
    <div class="my-3 py-3">
      <h2 class="display-5">Live Field Scoreboard test t est test </h2>
      <p class="lead">And an even wittieren wittie en wittieen wittie en wittiev subheading.</p>
    </div>
    <img src="/assets/images/marketing/teamPageCutoff.png" alt="Bootstrap Themes" width="300" loading="lazy">
  </div>
    <div class="col col-12 col-md-6 bg-body-tertiary pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
        <div class="my-3 p-3">
            <h2 class="display-5">Live XC Scoreboard</h2>
            <p class="lead">And an even wittier subheading And an even wittier subheading And an even wittier subheading.</p>
        </div>
      <img src="/assets/images/marketing/teamPageResults.png" alt="Bootstrap Themes" width="300" loading="lazy">
    </div>
</div>
<div class="d-md-flex flex-md-equal w-100 my-md-3 ps-md-3">
    <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
        <div class="my-3 p-3">
            <h2 class="display-5">Search</h2>
            <p class="lead">And an even wittier subheading.</p>
        </div>
        <div class="bg-dark shadow-sm mx-auto" style="width: 80%; height: 300px; border-radius: 21px 21px 0 0;"></div>
    </div>
    <div class="text-bg-primary me-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden">
        <div class="my-3 py-3">
            <h2 class="display-5">Notifications</h2>
            <p class="lead">And an even wittier subheading.</p>
        </div>
        <div class="bg-body-tertiary shadow-sm mx-auto" style="width: 80%; height: 300px; border-radius: 21px 21px 0 0;"></div>
    </div>
</div>
-->
